import { FlowStepRunner } from "../FlowStepRunner";
import { FlowExecutionData } from "../../Engine/FlowExecutionData";
import { ManyOutputTestStep } from "./ManyOutputTestStep";
import { IUserInfo } from "../../../Plugins/DataStorage/IUserInfo";
import { FlowEngine } from "../../Engine/FlowEngine";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { FlowStepTestContext } from "../../Structure/FlowTestingContext";

export class ManyOutputTestStepRunner extends FlowStepRunner<ManyOutputTestStep> {
    async start(
        _user: IUserInfo,
        _thread: string,
        _executionData: ExecutionData,
        _flowExecutionData: FlowExecutionData,
        testContext?: FlowStepTestContext
    ): Promise<void> {
        await FlowEngine.stepComplete(
            _user,
            _flowExecutionData,
            _thread,
            this.stepData!,
            this.stepData!.paths[0],
            testContext
        );
    }
}
